import { ITransactionDetailsInstallerLocations } from "./types";

export default class TransactionDetailsInstallerPosition implements ITransactionDetailsInstallerLocations {

  name: string;
  installerLocation: any;
  homeLocation: any;
  accessible: boolean;

  constructor(
    name: string,
    lastKnownLatitude: number,
    lastKnownLongitude: number,
    saLatitude: number | null,
    saLongitude: number | null,
    accessible: boolean) {
    this.name = name;
    this.installerLocation = {
      lat: lastKnownLatitude,
      lng: lastKnownLongitude,
    };
    this.homeLocation = {
      lat: saLatitude,
      lng: saLongitude,
    };
    this.accessible = accessible;
  }

}
